import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core'
import { HandlerOperationService } from 'src/app/services/handler.operation.service'
import { AWSService } from 'src/app/services/aws.service'
import { NotificationService } from 'src/app/services/notification.service'
import { eventToBase64 } from '../../../_helpers/Media'
import { ActivatedRoute } from '@angular/router'
import { DataTableDirective } from 'angular-datatables'
import { Subject } from 'rxjs'
import { IHandlerOperation, IGallery, Section, TypeOperationEnum, SpecialRecommendationEnum } from 'src/app/models/HandlerOperation'
import { ViewValidation } from 'src/app/_helpers/ViewValidation'
import { NgForm } from '@angular/forms'
import { deepcopy, insertOrRemoveClassInScrollButton, scrollToConteiner } from '../../../_helpers/Utils'
import { getEnableLegalFundamentation, getLengthTable, getLoggedUser, setLengthTable } from 'src/app/_helpers/LocalStorage'
import { UserAdmin } from 'src/app/models/UserAdmin'

@Component({
	selector: 'app-handler-operation',
	templateUrl: './handler-operation.component.html'
})
export class HandlerOperationComponent implements OnInit, AfterViewInit {

	constructor(
		private operationService: HandlerOperationService,
		private awsService: AWSService,
		public notificationService: NotificationService,
		private activateRoute: ActivatedRoute
	) {}

	@ViewChild(DataTableDirective) public dtElement: DataTableDirective
	@ViewChild('form') public form: NgForm
	@ViewChild('tableConteiner')
	public tableConteiner: ElementRef<HTMLDivElement>

	public refreshTable: Subject<any> = new Subject()
	public datatableOptions: DataTables.Settings = {}
	public operations: Array<IHandlerOperation> = []
	public specialRecommendations: Array<{value: string, label: string}> = []
	public typeOperations: Array<{value: string, label: string}> = []
	public companyId: string = localStorage.getItem('companyId')
	public sessionUser: UserAdmin = getLoggedUser()
	public enableLegalFundamentation: boolean = getEnableLegalFundamentation()
	public ViewValidation: ViewValidation = new ViewValidation()
	public showScrollUpButton: boolean = false
	public lengthTable: string = getLengthTable()

	public loading: boolean = false
	public isAdmin: boolean = false
	public openSections: boolean = false

	public modal: {
		isOpen: boolean
		isEditing?: boolean
		operation: IHandlerOperation
	} = {
		isOpen: false,
		isEditing: false,
		operation: this.getNewOperation()
	}

	public modalDelete: {
		isOpen: boolean
		operation: IHandlerOperation
	} = {
		isOpen: false,
		operation: this.getNewOperation()
	}

	public modalObsolete: {
		isOpen: boolean,
		handleOperationId: string
	} = {
		isOpen: false,
		handleOperationId: ''
	}

	public reRender(): void {
		if (this.dtElement.dtInstance) {
			this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
				document.querySelector('table').classList.add('hide')
				dtInstance.destroy()
				this.refreshTable.next()
				setTimeout(() => {
					document.querySelector('table').classList.remove('hide')
				}, 500)
			})
		} else {
			this.refreshTable.next()
		}
	}

	public async openModal(): Promise<void> {
		try {
			this.form.reset()
			this.modal.isOpen = true
			this.modal.operation.color = '#8d4e24'
			const modal: any = document.getElementsByClassName('modal active')
			setTimeout(() => {
				modal[0].scrollTop = 0
			}, 250)
		} catch (err) {
			console.log(err)
		}
	}

	public openModalDelete(operation: IHandlerOperation): void {
		this.modalDelete.isOpen = true
		this.modalDelete.operation = deepcopy(operation)
	}

	public closeModal(): void {
		this.modal.isEditing = false
		this.modal.isOpen = false
		this.modal.operation = this.getNewOperation()
	}

	public closeModalDelete(): void {
		this.modalDelete.isOpen = false
		this.modalDelete.operation = this.getNewOperation()
	}

	public async ngOnInit(): Promise<void> {
		this.isAdmin = Boolean(this.sessionUser.roles.includes('GENERAL_ADMIN'))

		this.specialRecommendations = await this.operationService.getSpecialRecommendations().toPromise()
		this.typeOperations = await this.operationService.getTypeOperations().toPromise()

		this.notificationService.starterLoading.subscribe(
			() => (this.loading = true)
		)
		this.notificationService.stopperLoading.subscribe(
			() => (this.loading = false)
		)
		this.fetchTableResolver()
		this.setupDatatables()

		const observer =
			new IntersectionObserver( ([entry]) => {
				this.showScrollUpButton = entry.isIntersecting

				if (entry.isIntersecting) {
					insertOrRemoveClassInScrollButton()
				}
			})

		observer.observe(this.tableConteiner.nativeElement)
	}

	public ngAfterViewInit(): void {
		this.refreshTable.next()
	}

	private setupDatatables(): void {
		this.datatableOptions = {
			language: {
				processing: 'Processando...',
				lengthMenu: '_MENU_ resultados por página',
				info: 'Mostrando de _START_ até _END_ de _TOTAL_ registros',
				infoEmpty: 'Mostrando 0 até 0 de 0 registros',
				infoFiltered: '',
				infoPostFix: '',
				zeroRecords: '...',
				loadingRecords: 'Cargando...',
				emptyTable: 'Nenhum registro encontrado',
				paginate: {
					first: 'Primero',
					previous: 'Anterior',
					next: 'Próximo',
					last: 'Último'
				},
				aria: {
					sortAscending: ': Ordenar colunas de forma ascendente',
					sortDescending: ': Ordenar colunas de forma ascendente'
				}
			},
			pagingType: 'full_numbers',
			paging: true,
			searching: true,
			ordering: true,
			info: true,
			autoWidth: false,
			pageLength: Number(this.lengthTable),
			lengthChange: false,
			columnDefs: [
				{
					targets: 'no-sort',
					orderable: false,
					width: '.1%'
				}
			]
		}
	}

	public fetchTableResolver(): void {
		this.operations = this.activateRoute.snapshot.data.operations
	}

	public async fetchTableSimple(): Promise<void> {
		const response: any = await this.operationService
			.list(this.companyId, true)
			.toPromise()
		this.operations = response
		this.reRender()
	}

	public async onSubmit(): Promise<void> {
		try {
			this.modal.operation.company = this.companyId
			this.notificationService.initLoading()

			const toSend: Array<IGallery> = this.modal.operation.gallery.filter(
				item => {
					return item.type !== 'UPLOADED'
				}
			)
			const toKeep: Array<IGallery> = this.modal.operation.gallery.filter(
				item => {
					return item.type === 'UPLOADED'
				}
			)
			const gallery: any = await this.awsService.sendListPromise(toSend)
			const urls: Array<IGallery> = gallery.map(item => ({
				type: 'UPLOADED',
				string: item.Location,
				file: item
			}))
			urls.forEach(url => {
				toKeep.push(url)
			})

			this.modal.operation.gallery = toKeep.map(item => item.string)

			if (this.modal.isEditing) {
				const response: any = await this.operationService
					.edit(this.modal.operation)
					.toPromise()
				this.notificationService.stopLoading()
				this.fetchTableSimple()

				this.modal.isEditing = false
				this.modal.isOpen = false
				this.modal.operation.operation = ''
				this.modal.operation.instructions = ''
				this.modal.operation.description = ''
				this.modal.operation.gallery = []

				this.notificationService.notify(response.message, 200)

				return
			}

			const response: any = await this.operationService
				.create(this.modal.operation)
				.toPromise()

			this.notificationService.stopLoading()
			this.modal.isOpen = false
			this.modal.operation = this.getNewOperation()
			this.notificationService.notify(response.message, 200)
			await this.fetchTableSimple()
		} catch (err) {
			console.log(err)
		}
	}

	public async handleFileInput(event: any): Promise<void> {
		try {
			if (this.modal.operation.gallery.length === 4) {
				this.notificationService.notify('Máximo de 4 imagens', 420)
				return
			}

			const file: any = event.target.files[0]
			const type: string = file.type.split('/')[0]
			if (type !== 'image') throw new Error('')
			const base64: any = await eventToBase64(event)
			this.modal.operation.gallery.push({
				type: 'base64',
				string: base64,
				file
			})
			event.target.value = ''
		} catch (err) {
			this.notificationService.notify('Formato não aceito...', 420)
		}
	}

	public deletePhoto(index: number): void {
		if (this.modal.operation.status === 'OBSOLETE') {
			return
		}

		this.modal.operation.gallery.splice(index, 1)
	}

	public clearGallery(): void {
		if (this.modal.operation.status === 'OBSOLETE') {
			return
		}

		this.modal.operation.gallery = []
	}

	public async delete(): Promise<void> {
		try {
			const operation: IHandlerOperation = this.modalDelete.operation
			const response: any = await this.operationService
				.delete(operation._id)
				.toPromise()
			this.fetchTableSimple()
			this.closeModalDelete()
			this.notificationService.notify(response.message, 200)
		} catch (err) {
			console.log(err)
		}
	}

	public async edit(item: IHandlerOperation): Promise<void> {
		try {
			const operation: IHandlerOperation = await this.operationService
				.get(item._id)
				.toPromise()

			const gallery: Array<IGallery> = operation.gallery.map(x => ({
				string: x,
				type: 'UPLOADED'
			}))

			this.modal.operation = { ...operation, gallery }
			this.modal.isEditing = true
			this.modal.isOpen = true

			const modal: any = document.getElementsByClassName('modal active')
			setTimeout(() => {
				modal[0].scrollTop = 0
			}, 250)
		} catch (err) {
			console.log(err)
		}
	}

	public checkForm(): boolean {
		if (this.modal.operation.operation.length === 0) {
			return false
		}
		if (this.modal.operation.instructions.length === 0) {
			return false
		}
		if (this.modal.operation.description.length === 0) {
			return false
		}
		// GALLERY
		if (this.modal.operation.gallery.length === 0) {
			return false
		}

		return true
	}

	public getNewOperation(): IHandlerOperation {
		const operation: IHandlerOperation = {}
		operation.operation = ''
		operation.instructions = ''
		operation.description = ''
		operation.gallery = []
		operation.color = '#8d4e24'
		operation.specialRecommendation = SpecialRecommendationEnum.NONE
		operation.typeOperation = TypeOperationEnum.DEFAULT
		operation.sections = []

		return operation
	}

	public updateLengthTable(newLength: string) {
		this.datatableOptions.pageLength = parseInt(newLength)
		this.reRender()
		setLengthTable(newLength)
	}

	public runToInitTable() {
		const table: HTMLDivElement =
			document.getElementsByClassName('datatables-content')[0] as HTMLDivElement

		scrollToConteiner(table)
		insertOrRemoveClassInScrollButton()
	}

	public openModalObsolete(handleOperationId: string): void {
		this.modalObsolete.isOpen = true
		this.modalObsolete.handleOperationId = handleOperationId
	}

	public closeModalObsolete(): void {
		this.modalObsolete.isOpen = false
		this.modalObsolete.handleOperationId = ''
	}

	public async obsoleteHandleOperation(): Promise<void> {

		const handleOperation =
			this.operations.find(operation =>
				operation._id === this.modalObsolete.handleOperationId &&
				operation.status === 'OBSOLETE'
			)

		if (handleOperation) {
			this.notificationService.notify('O Manejo já está obsoleto', 500)
			this.closeModalObsolete()
			return
		}

		try {
			const response: string =
				await this.operationService.obsolete(this.modalObsolete.handleOperationId).toPromise()

			this.notificationService.notify(response, 200)

			this.fetchTableSimple()
			this.closeModalObsolete()
		} catch (err) {
			console.log(err)
			this.closeModalObsolete()
		}
	}

	public openCloseSections() {
		this.openSections = !this.openSections
	}

	public updateSectionInHandlerOperation(sections: Array<Section>) {
		this.modal.operation.sections = sections
	}
}
